import React from 'react';
import { apiGet } from '../../../store/apiWrapper';
import { Circles } from '../../common/loadingComponent';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Translate } from 'react-localize-redux';
import ExcelExportButton from '../../common/excelExportButton';
import HorizontalScrollControl from '../../layoutItems/horizontalScrollControl';
import NoDataComponent from '../../common/noDataComponent';

import "../../../css/search/search.scss";

class SummaryHistoryResult extends React.Component {
    state = {
        data: [],
        isLoading: false,
    };

    render() {
        if (isNullOrUndefined(this.props.year) || isNullOrUndefined(this.props.summary) || isNullOrUndefined(this.props.division))
            return (<NoDataComponent />);

        if (this.state.isLoading)
            return <Circles />

        return (
            <>
                <div className='card card-special' >
                    <div className='card-body'>
                        {this.renderTitle()}
                        <HorizontalScrollControl withMarginBottom>
                            <table className="table table-report-section-2-general-asm without-hover w-100">
                                <tbody>{this.renderHeader()}</tbody>
                                <tbody>{this.renderLabels()}</tbody>
                                <tbody>{this.renderBody()}</tbody>
                            </table>
                        </HorizontalScrollControl>
                        <ExcelExportButton report="summary" ratiobook={{ year: this.props.year, summary: this.props.summary, division: this.props.division, type: "summary-history" }} />
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        apiGet(`${window.babylonApiUrl}/api/ratiobook/summary-history?year=${this.props.year}&summary=${this.props.summary}&division=${this.props.division}`,
            null,
            (data) => this.success(data.data),
            () => this.onError()
        );
    }

    renderTitle() {
        if (this.state.data.length == 0)
            return;

        return (
            <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                <h5 className="underlined-title rb-header">
                    <Translate id="RatioBook.Common.SummaryOverview" options={{ renderInnerHtml: true }} />
                    {`: ${this.state.data.summaryTitle} - ${this.state.data.divisionTitle} (${this.props.year})`}
                </h5>
            </span>
        );
    }

    renderHeader() {
        if (this.state.data.length == 0)
            return;

        const { year, header } = this.state.data;

        for (let i = 0; i < header.length; i++) {

            if (header[i].type == "T1" && header[i].year == year) this.t4 = header[i].value;
            if (header[i].type == "T1" && header[i].year == year - 1) this.t3 = header[i].value;
            if (header[i].type == "T1" && header[i].year == year - 2) this.t2 = header[i].value;
            if (header[i].type == "T1" && header[i].year == year - 3) this.t1 = header[i].value;

        }

        return (
            <React.Fragment>
                <tr>
                    <td>{<Translate id="RatioBook.Common.BusinessSubjects" options={{ renderInnerHtml: true }} />}</td>
                    <td></td>
                    <td>{<Translate id="RatioBook.Common.Count" options={{ renderInnerHtml: true }} />}</td>
                    <td className="right">{this.t1}</td>
                    <td className="right">{this.t2}</td>
                    <td className="right">{this.t3}</td>
                    <td className="right">{this.t4}</td>
                </tr>
            </React.Fragment>
        );
    }

    renderLabels() {
        if (this.state.data.length == 0)
            return;

        const { year } = this.state.data;

        return (
            <React.Fragment>
                <tr>
                    <th rowSpan="2" >{<Translate id="RatioBook.Common.Ratio" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.StatChar" options={{ renderInnerHtml: true }} />}</th>
                    <th rowSpan="2" className="center">{<Translate id="RatioBook.Common.Unit" options={{ renderInnerHtml: true }} />}</th>
                    <th colSpan="4" className="center">{`${this.state.data.summaryTitle}`}</th>
                </tr>
                <tr>
                    <th className="center">{year - 3}</th>
                    <th className="center">{year - 2}</th>
                    <th className="center">{year - 1}</th>
                    <th className="center">{year}</th>
                </tr>
            </React.Fragment >
        );
    }

    renderBody() {
        if (this.state.data.length == 0)
            return;

        const dk = <Translate id="RatioBook.Common.DK" options={{ renderInnerHtml: true }} />
        const hk = <Translate id="RatioBook.Common.HK" options={{ renderInnerHtml: true }} />
        const me = <Translate id="RatioBook.Common.Me" options={{ renderInnerHtml: true }} />

        const { year, body } = this.state.data;
        return body.map(item => {
            return (
                <React.Fragment key={this.key}>
                    {this.getData(item, year, dk, me, hk)}
                </React.Fragment>
            )
        });
    }

    getData(item, year, dk, me, hk) {
        var row = {};

        for (let i = 0; i < item.data.length; i++) {

            if (item.data[i].type == "T1" && item.data[i].year == year - 3) {
                row.dk_1 = !item.data[i].isNullOrUndefined ? item.data[i].dk : 0;
                row.me_1 = !item.data[i].isNullOrUndefined ? item.data[i].me : 0;
                row.hk_1 = !item.data[i].isNullOrUndefined ? item.data[i].hk : 0;
            }

            if (item.data[i].type == "T1" && item.data[i].year == year - 2) {
                row.dk_2 = !item.data[i].isNullOrUndefined ? item.data[i].dk : 0;
                row.me_2 = !item.data[i].isNullOrUndefined ? item.data[i].me : 0;
                row.hk_2 = !item.data[i].isNullOrUndefined ? item.data[i].hk : 0;
            }

            if (item.data[i].type == "T1" && item.data[i].year == year - 1) {
                row.dk_3 = !item.data[i].isNullOrUndefined ? item.data[i].dk : 0;
                row.me_3 = !item.data[i].isNullOrUndefined ? item.data[i].me : 0;
                row.hk_3 = !item.data[i].isNullOrUndefined ? item.data[i].hk : 0;
            }

            if (item.data[i].type == "T1" && item.data[i].year == year) {
                row.dk_4 = !item.data[i].isNullOrUndefined ? item.data[i].dk : 0;
                row.me_4 = !item.data[i].isNullOrUndefined ? item.data[i].me : 0;
                row.hk_4 = !item.data[i].isNullOrUndefined ? item.data[i].hk : 0;
            }

        }
        row.name = item.description;
        row.unit = item.unit;

        return (this.renderBodyItemRow(row, dk, me, hk));
    }

    renderBodyItemRow(row, dk, me, hk) {
        return (
            <React.Fragment>
                <tr>
                    <td rowSpan="3">{row.name}</td>
                    <td className="center">{dk}</td>
                    <td rowSpan="3">{row.unit}</td>
                    <td className="right">{row.dk_1}</td>
                    <td className="right">{row.dk_2}</td>
                    <td className="right">{row.dk_3}</td>
                    <td className="right">{row.dk_4}</td>
                </tr>
                <tr>
                    <td className="center">{me}</td>
                    <td className="right">{row.me_1}</td>
                    <td className="right">{row.me_2}</td>
                    <td className="right">{row.me_3}</td>
                    <td className="right">{row.me_4}</td>
                </tr>
                <tr>
                    <td className="center">{hk}</td>
                    <td className="right">{row.hk_1}</td>
                    <td className="right">{row.hk_2}</td>
                    <td className="right">{row.hk_3}</td>
                    <td className="right">{row.hk_4}</td>
                </tr>
            </React.Fragment>
        )
    }

    success(data) {
        this.setState({ data: data, isLoading: false });
    }

    onError() {
        this.setState({ isLoading: false });
    }
}

export default SummaryHistoryResult;